module.exports = __webpack_public_path__ + "static/img/interview.4570ddc7.png";